(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return REDUCED_MOTION.matches;
  }

  function initReveal(root) {
    var scope = root || document;
    var elements = scope.querySelectorAll('.reveal:not(.is-visible)');

    if (!elements.length) return;

    if (prefersReducedMotion()) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function setLoaderProgress(section, loader, progress) {
    var value = Math.max(0, Math.min(1, progress));
    var formatted = value.toFixed(4);
    var bottomClip = (value * 100).toFixed(2) + '%';
    var topClip = ((1 - value) * 100).toFixed(2) + '%';
    var darkClip = 'inset(0 0 ' + bottomClip + ' 0)';
    var lightClip = 'inset(' + topClip + ' 0 0 0)';
    var loadingTitle = section.querySelector('.section-hero__loading-title');

    loader.style.setProperty('--hero-loader-progress', formatted);
    section.style.setProperty('--hero-loader-progress', formatted);
    section.style.setProperty('--hero-loader-clip-dark', darkClip);
    section.style.setProperty('--hero-loader-clip-light', lightClip);

    if (loadingTitle) {
      loadingTitle.style.setProperty('--hero-loader-clip-dark', darkClip);
      loadingTitle.style.setProperty('--hero-loader-clip-light', lightClip);
    }

    syncHeaderLoaderTone(value);
  }

  var headerLoaderToneActive = false;
  var headerLoaderResizeBound = false;

  function shouldUseHeaderLoaderTone() {
    return (
      document.body.classList.contains('has-transparent-header') &&
      !document.body.classList.contains('header-scrolled') &&
      !document.body.classList.contains('hero-media-ready')
    );
  }

  function computeHeaderLoaderClips(progress) {
    var nav = document.querySelector('.bhcr-header__nav');
    if (!nav) return null;

    var rect = nav.getBoundingClientRect();
    if (!rect.height) return null;

    var boundaryY = (1 - progress) * window.innerHeight;
    var lightHeight = Math.max(0, Math.min(rect.bottom, boundaryY) - rect.top);
    var ratio = Math.max(0, Math.min(1, lightHeight / rect.height));
    var lightTop = (ratio * 100).toFixed(2) + '%';
    var darkBottom = ((1 - ratio) * 100).toFixed(2) + '%';

    return {
      dark: 'inset(0 0 ' + darkBottom + ' 0)',
      light: 'inset(' + lightTop + ' 0 0 0)',
    };
  }

  function syncHeaderLoaderTone(progress) {
    if (!headerLoaderToneActive || !shouldUseHeaderLoaderTone()) return;

    var nav = document.querySelector('.bhcr-header__nav');
    var clips = computeHeaderLoaderClips(progress);
    if (!nav || !clips) return;

    nav.style.setProperty('--hero-header-clip-dark', clips.dark);
    nav.style.setProperty('--hero-header-clip-light', clips.light);
  }

  function onHeaderLoaderResize() {
    var hero = document.querySelector('.section-hero[data-hero-loader].is-loading');
    if (!hero || !headerLoaderToneActive) return;

    var progress = parseFloat(hero.style.getPropertyValue('--hero-loader-progress'));
    if (!isFinite(progress)) progress = 0;
    syncHeaderLoaderTone(progress);
  }

  function bindHeaderLoaderResize() {
    if (headerLoaderResizeBound) return;
    headerLoaderResizeBound = true;
    window.addEventListener('resize', onHeaderLoaderResize);
  }

  function unbindHeaderLoaderResize() {
    if (!headerLoaderResizeBound) return;
    headerLoaderResizeBound = false;
    window.removeEventListener('resize', onHeaderLoaderResize);
  }

  function enableHeaderLoaderTone() {
    if (!shouldUseHeaderLoaderTone()) return;

    var nav = document.querySelector('.bhcr-header__nav');
    var inner = nav && nav.querySelector('.bhcr-header__nav-inner');
    if (!nav || !inner || nav.dataset.loaderToneInit === 'true') {
      headerLoaderToneActive = true;
      document.body.classList.add('hero-header-loading');
      return;
    }

    nav.dataset.loaderToneInit = 'true';
    var markup = inner.innerHTML;

    var dark = document.createElement('div');
    dark.className = 'bhcr-header__nav-tone bhcr-header__nav-tone--dark';
    dark.setAttribute('aria-hidden', 'true');
    dark.innerHTML = markup;

    var light = document.createElement('div');
    light.className = 'bhcr-header__nav-tone bhcr-header__nav-tone--light';
    light.setAttribute('aria-hidden', 'true');
    light.innerHTML = markup;

    inner.classList.add('bhcr-header__nav-inner--interactive');
    nav.classList.add('bhcr-header__nav--loader-tone');
    nav.insertBefore(dark, inner);
    nav.insertBefore(light, inner);

    headerLoaderToneActive = true;
    document.body.classList.add('hero-header-loading');
    bindHeaderLoaderResize();
  }

  function disableHeaderLoaderTone() {
    headerLoaderToneActive = false;
    document.body.classList.remove('hero-header-loading');
    unbindHeaderLoaderResize();

    var nav = document.querySelector('.bhcr-header__nav');
    if (!nav || nav.dataset.loaderToneInit !== 'true') return;

    nav.querySelectorAll('.bhcr-header__nav-tone').forEach(function (el) {
      el.remove();
    });

    var inner = nav.querySelector('.bhcr-header__nav-inner');
    if (inner) inner.classList.remove('bhcr-header__nav-inner--interactive');

    nav.classList.remove('bhcr-header__nav--loader-tone');
    nav.style.removeProperty('--hero-header-clip-dark');
    nav.style.removeProperty('--hero-header-clip-light');
    delete nav.dataset.loaderToneInit;
  }

  function markHeroMediaReady() {
    document.body.classList.add('hero-media-ready');
    disableHeaderLoaderTone();
  }

  function resetHeroVideoToStart(video) {
    if (!video) return;

    video.pause();

    if (video.readyState >= 1) {
      try {
        video.currentTime = 0;
      } catch (error) {
        // Seek can fail before the browser has seekable ranges.
      }
    }
  }

  function startHeroVideoAtBeginning(video, shouldPlay) {
    if (!video) return;

    var play = shouldPlay !== false;

    function apply() {
      resetHeroVideoToStart(video);

      if (!play) return;

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(function () {});
      }
    }

    if (video.readyState >= 1) {
      apply();
      return;
    }

    video.addEventListener('loadedmetadata', apply, { once: true });
  }

  function bindHeroVideoLoadGuard(video, section) {
    if (!video || video.dataset.heroLoadGuard === 'true') return;
    video.dataset.heroLoadGuard = 'true';

    video.addEventListener(
      'loadedmetadata',
      function () {
        if (!section.classList.contains('is-media-ready')) {
          resetHeroVideoToStart(video);
        }
      },
      { once: true }
    );

    video.addEventListener('play', function () {
      if (!section.classList.contains('is-media-ready')) {
        resetHeroVideoToStart(video);
      }
    });
  }

  function revealHero(section, loader) {
    setLoaderProgress(section, loader, 1);
    section.classList.remove('is-loading');
    section.classList.add('is-media-ready');
    startHeroVideoAtBeginning(section.querySelector('video.section-hero__media'), true);
    markHeroMediaReady();
    loader.addEventListener(
      'animationend',
      function (event) {
        if (event.animationName !== 'bhcrHeroLoaderExit') return;
        loader.hidden = true;
      }
    );
  }

  // Pick a byte-trackable progressive source. HLS playlists (.m3u8) reference
  // many segment files and cannot be measured as a single download, so we
  // prefer an explicit MP4 source and fall back to any non-HLS URL.
  function getProgressiveVideoUrl(video) {
    var sources = video.querySelectorAll('source');

    for (var i = 0; i < sources.length; i++) {
      var type = (sources[i].getAttribute('type') || '').toLowerCase();
      if (sources[i].src && type.indexOf('mp4') !== -1) return sources[i].src;
    }

    for (var j = 0; j < sources.length; j++) {
      var src = sources[j].src || '';
      if (src && src.indexOf('.m3u8') === -1) return src;
    }

    var current = video.currentSrc || '';
    if (current && current.indexOf('.m3u8') === -1) return current;

    return null;
  }

  // The full GET response often omits Content-Length (proxies, chunked
  // transfer), but a tiny range request reliably reports the total size via
  // the Content-Range header (e.g. "bytes 0-0/8362384").
  function fetchVideoTotalBytes(url) {
    return fetch(url, { headers: { Range: 'bytes=0-0' } })
      .then(function (response) {
        var range = response.headers.get('content-range');
        if (range && range.indexOf('/') !== -1) {
          var total = parseInt(range.split('/').pop(), 10);
          if (isFinite(total) && total > 0) return total;
        }

        var length = parseInt(response.headers.get('content-length') || '', 10);
        return isFinite(length) && length > 1 ? length : 0;
      })
      .catch(function () {
        return 0;
      });
  }

  function downloadVideoToBlob(url, total, onProgress) {
    return fetch(url).then(function (response) {
      if (!response.ok || !response.body || !response.body.getReader) {
        throw new Error('hero-video-stream-unsupported');
      }

      var knownTotal =
        total || parseInt(response.headers.get('content-length') || '', 10) || 0;
      var reader = response.body.getReader();
      var chunks = [];
      var received = 0;

      function pump() {
        return reader.read().then(function (result) {
          if (result.done) {
            return new Blob(chunks, { type: 'video/mp4' });
          }

          chunks.push(result.value);
          received += result.value.length;

          if (knownTotal > 0) {
            // Cap below 1 so the loader only completes once the blob is ready.
            onProgress(Math.min(0.999, received / knownTotal));
          }

          return pump();
        });
      }

      return pump();
    });
  }

  function applyBlobToVideo(video, blobUrl) {
    video.querySelectorAll('source').forEach(function (source) {
      source.remove();
    });
    video.src = blobUrl;
    video.load();
  }

  function waitForVideoPlayable(video) {
    return new Promise(function (resolve) {
      if (video.readyState >= 3) {
        resolve();
        return;
      }

      function done() {
        video.removeEventListener('canplay', done);
        video.removeEventListener('loadeddata', done);
        video.removeEventListener('error', done);
        resolve();
      }

      video.addEventListener('canplay', done);
      video.addEventListener('loadeddata', done);
      video.addEventListener('error', done);
    });
  }

  // Fallback when the video cannot be streamed (cross-origin without CORS, or
  // HLS-only sources): drive the loader from native buffering and reveal once
  // the browser reports it can play through.
  function trackVideoLoadFallback(video, section, loader, resolve) {
    var settled = false;
    var maxProgress = 0;
    var safetyTimeout = setTimeout(finish, 120000);

    function bufferProgress() {
      var duration = video.duration;
      if (!duration || !isFinite(duration) || duration <= 0) {
        return video.readyState >= 3 ? 0.5 : 0;
      }

      try {
        var buffered = video.buffered;
        if (!buffered || !buffered.length) return 0;

        var end = 0;
        for (var i = 0; i < buffered.length; i++) {
          end = Math.max(end, buffered.end(i));
        }

        return Math.min(1, end / duration);
      } catch (error) {
        return 0;
      }
    }

    function finish() {
      if (settled) return;
      settled = true;
      clearTimeout(safetyTimeout);
      video.removeEventListener('progress', update);
      video.removeEventListener('loadedmetadata', update);
      video.removeEventListener('canplaythrough', finish);
      video.removeEventListener('suspend', update);
      video.removeEventListener('error', finish);
      setLoaderProgress(section, loader, 1);
      resolve();
    }

    function update() {
      if (settled) return;
      maxProgress = Math.max(maxProgress, bufferProgress());
      setLoaderProgress(section, loader, maxProgress);
      if (bufferProgress() >= 0.999) finish();
    }

    video.addEventListener('progress', update);
    video.addEventListener('loadedmetadata', update);
    video.addEventListener('canplaythrough', finish);
    video.addEventListener('suspend', update);
    video.addEventListener('error', finish, { once: true });

    update();
  }

  function trackVideoLoad(video, section, loader, resolve) {
    resetHeroVideoToStart(video);
    bindHeroVideoLoadGuard(video, section);

    var url = getProgressiveVideoUrl(video);
    var canStream =
      url &&
      typeof window.fetch === 'function' &&
      typeof window.ReadableStream !== 'undefined';

    if (!canStream) {
      trackVideoLoadFallback(video, section, loader, resolve);
      return;
    }

    setLoaderProgress(section, loader, 0);

    var lastShown = 0;
    function onProgress(fraction) {
      // Throttle CSS/layout writes to ~0.5% steps to avoid reflow thrash.
      if (fraction - lastShown < 0.005 && fraction < 0.999) return;
      lastShown = fraction;
      setLoaderProgress(section, loader, fraction);
    }

    fetchVideoTotalBytes(url)
      .then(function (total) {
        return downloadVideoToBlob(url, total, onProgress);
      })
      .then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);

        if (video.dataset.heroBlobUrl) {
          URL.revokeObjectURL(video.dataset.heroBlobUrl);
        }
        video.dataset.heroBlobUrl = blobUrl;

        applyBlobToVideo(video, blobUrl);
        return waitForVideoPlayable(video);
      })
      .then(function () {
        setLoaderProgress(section, loader, 1);
        resolve();
      })
      .catch(function () {
        // Streaming failed mid-way — degrade to native buffering.
        trackVideoLoadFallback(video, section, loader, resolve);
      });
  }

  function trackImageLoad(image, section, loader, resolve) {
    function finish() {
      setLoaderProgress(section, loader, 1);
      resolve();
    }

    if (image.complete && image.naturalWidth > 0) {
      finish();
      return;
    }

    image.addEventListener('load', finish, { once: true });
    image.addEventListener('error', finish, { once: true });
  }

  function trackIframeLoad(iframe, section, loader, resolve) {
    // Embedded players do not expose buffer progress; loader completes when the iframe shell loads.
    function finish() {
      setLoaderProgress(section, loader, 1);
      resolve();
    }

    try {
      if (iframe.contentDocument && iframe.contentDocument.readyState === 'complete') {
        finish();
        return;
      }
    } catch (error) {
      // Cross-origin embeds cannot be inspected; wait for the load event.
    }

    iframe.addEventListener('load', finish, { once: true });
    iframe.addEventListener('error', finish, { once: true });
  }

  function trackHeroMediaLoad(section, loader) {
    return new Promise(function (resolve) {
      var video = section.querySelector('video.section-hero__media');
      var image = section.querySelector('.section-hero__media--image');
      var iframe = section.querySelector('.section-hero__iframe');
      var placeholder = section.querySelector('.section-hero__media--placeholder');

      setLoaderProgress(section, loader, 0);

      if (placeholder) {
        setLoaderProgress(section, loader, 1);
        resolve();
        return;
      }

      if (video) {
        trackVideoLoad(video, section, loader, resolve);
        return;
      }

      if (image) {
        trackImageLoad(image, section, loader, resolve);
        return;
      }

      if (iframe) {
        trackIframeLoad(iframe, section, loader, resolve);
        return;
      }

      setLoaderProgress(section, loader, 1);
      resolve();
    });
  }

  function destroyHeroLoader(section) {
    if (!section) return;

    var video = section.querySelector('video.section-hero__media');
    if (video) {
      resetHeroVideoToStart(video);
      if (video.dataset.heroBlobUrl) {
        URL.revokeObjectURL(video.dataset.heroBlobUrl);
        delete video.dataset.heroBlobUrl;
      }
    }

    section.classList.remove('is-loading');
    section.classList.remove('is-media-ready');
    delete section.dataset.heroLoaderInit;
    section.style.removeProperty('--hero-loader-progress');
    section.style.removeProperty('--hero-loader-clip-dark');
    section.style.removeProperty('--hero-loader-clip-light');

    var loader = section.querySelector('.section-hero__loader');
    if (loader) {
      loader.hidden = false;
      loader.style.removeProperty('--hero-loader-progress');
    }
  }

  function initHeroLoader(section) {
    if (!section || section.dataset.heroLoaderInit === 'true') return;

    var loader = section.querySelector('.section-hero__loader');
    if (!loader) return;

    section.dataset.heroLoaderInit = 'true';

    if (prefersReducedMotion()) {
      section.classList.add('is-media-ready');
      startHeroVideoAtBeginning(section.querySelector('video.section-hero__media'), false);
      markHeroMediaReady();
      return;
    }

    section.classList.add('is-loading');
    enableHeaderLoaderTone();
    setLoaderProgress(section, loader, 0);

    trackHeroMediaLoad(section, loader).then(function () {
      revealHero(section, loader);
    });
  }

  function initHeroSections(root) {
    var scope = root || document;
    var heroLoaders = scope.querySelectorAll('.section-hero[data-hero-loader]');
    heroLoaders.forEach(initHeroLoader);

    if (
      document.body.classList.contains('has-transparent-header') &&
      !document.body.classList.contains('hero-media-ready') &&
      heroLoaders.length === 0
    ) {
      document.body.classList.add('hero-media-ready');
    }
  }

  function init(scope) {
    initReveal(scope);
    initHeroSections(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.section-hero[data-hero-loader]').forEach(destroyHeroLoader);
  });

  REDUCED_MOTION.addEventListener('change', function () {
    init();
  });
})();
